import {Button} from '@wandb/components';
import React from 'react';

import {usePart, useViewAction} from '../../../state/views/hooks';
import * as PanelBankConfigActions from '../../../state/views/panelBankConfig/actions';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';
import {usePanelsQuickAddContext} from '../../WorkspaceDrawer/PanelsQuickAdd/PanelsQuickAddContext';

export const AddSectionButton = () => {
  const {closeQuickAdd} = usePanelsQuickAddContext();
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const panelBankConfigPart = usePart(panelBankConfigRef);
  const addSection = useViewAction(
    panelBankConfigRef,
    PanelBankConfigActions.addSection
  );
  const {sectionRefs} = panelBankConfigPart;
  const hiddenSectionRef = sectionRefs[sectionRefs.length - 1];
  // ^ NOTE: this assumes Hidden Panels is the last section

  return (
    <Button
      variant="secondary"
      startIcon="add-new"
      onPress={() => {
        closeQuickAdd();
        addSection(hiddenSectionRef);
      }}>
      Add section
    </Button>
  );
};
